import { noop } from '@moda/portal-stanchions';
import React, { createContext, FC, useState, useCallback } from 'react';

export const AuthModalContext = createContext({
  show: false,
  openAuthModal: (onSuccessCallback?: () => void, onFailureCallback?: () => void) => {
    onSuccessCallback;
    onFailureCallback;
    return;
  },
  closeAuthModal: noop,
  handleAuthSuccess: noop,
  handleAuthFailure: noop
});

export const AuthModalProvider: FC = ({ children }) => {
  const [show, setShow] = useState(false);
  const [onSuccessCallback, setOnSuccessCallback] = useState<typeof noop>(noop);
  const [onFailureCallback, setOnFailureCallback] = useState<typeof noop>(noop);

  const clearCallbacks = useCallback(() => {
    setOnSuccessCallback(() => noop);
    setOnFailureCallback(() => noop);
  }, []);

  const openAuthModal = useCallback(
    (onSuccess?: () => void, onFailure?: () => void) => {
      setShow(true);

      setOnSuccessCallback(() => () => {
        onSuccess && onSuccess();
        clearCallbacks();
      });

      setOnFailureCallback(() => () => {
        onFailure && onFailure();
        clearCallbacks();
      });
    },
    [clearCallbacks]
  );

  const closeAuthModal = useCallback(() => {
    clearCallbacks();
    setShow(false);
  }, [clearCallbacks]);

  return (
    <AuthModalContext.Provider
      value={{
        show,
        openAuthModal,
        closeAuthModal,
        handleAuthSuccess: onSuccessCallback,
        handleAuthFailure: onFailureCallback
      }}
    >
      {children}
    </AuthModalContext.Provider>
  );
};
